// extracted by mini-css-extract-plugin
export default {"container":"Qs-z","heading":"Rs-z","text":"Ss-z","info":"Ts-z","link":"Us-z","fullMaxWidth":"Vs-z"};